import React from "react";
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';

export default function SearchHeader({router}) {

    const [value, setValue] = React.useState(0);

    return (
        <div className="d-flex justify-content-end ">
            {(router || []).find(x=> x.actionDataKey ==="SEARCH_KRYS" && x.isActive)  &&   <div className={"search"}>
                <div className={"searchIcon"}>
                    <SearchIcon />
                </div>
              <InputBase
                    placeholder="Search…"
                    classes={{
                        root: "inputRoot",
                        input: "inputInput",
                    }}
                    inputProps={{ 'aria-label': 'search' }}
                />
            
            </div>
             }
        </div>
    )
}